import { Popover, PopoverTrigger, Box } from "@chakra-ui/react";

import PopoverContent from "modules/experiments/AhPlusPricingPlans/PopoverContent";
import type { PopoverIconProps } from "./PopoverIcon.d";

const PopoverIcon = ({ icon, content }: PopoverIconProps) => (
  <Popover trigger="hover" placement="top-start">
    <PopoverTrigger>
      <Box as="span" role="button" tabIndex={0} ml={1}>
        {icon}
      </Box>
    </PopoverTrigger>
    <PopoverContent heading={null} content={content} />
  </Popover>
);

export default PopoverIcon;
